import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";

export default function ConfirmStorePickup(props) {
  const {
    show,
    closeModal,
    isMobile,
    shippingCharges,
    setShippingChargesConfirmed,
    cancelPlaceOrder,
    setShippingCharges,
  } = props;
  return (
    <Modal show={show} className="confirm-order-modal">
      <Alert variant="success" className={isMobile ? "w-100" : "w-50"}>
        <Alert.Heading>Confirm Shipping Charges</Alert.Heading>
        <hr />
        <p>{`Shipping charges are Rs.${shippingCharges}. Continue to place order`}</p>
        <div className="d-flex justify-content-end">
          <div
            className="d-flex justify-content-between mt-2"
            style={{ width: isMobile ? "68%" : "30%" }}
          >
            <Button
              className="w-50 mr-2"
              onClick={() => {
                setShippingChargesConfirmed(true);
                closeModal();
              }}
              variant="outline-success"
            >
              Confirm
            </Button>
            <Button
              className="w-50"
              onClick={() => {
                setShippingChargesConfirmed(false);
                setShippingCharges(null);
                cancelPlaceOrder();
                closeModal();
              }}
              variant="outline-success"
            >
              Cancel
            </Button>
          </div>
        </div>
      </Alert>
    </Modal>
  );
}
